import { headerNames } from './types';

export const DEFAULT_VISIBLE_HEADERS: { [key: string]: string[] } = {
    [headerNames.datasetDetail]: ['period', 'data_version', 'currency', 'oos_response_date'],
    [headerNames.publishedDatasets]: ['period', 'data_version'],
    [headerNames.fundDatasets]: ['currency', 'period', 'data_version', 'data_source', 'updated_at'],
    [headerNames.fundList]: ['firm_fund'],
    [headerNames.profilesGroupsTargetSection]: ['firm_fund'],
};
